// extracted by mini-css-extract-plugin
export default {"button":"GoogleLogin_button__2DMsN","c8cb4305a":"GoogleLogin_c8cb4305a__vT0X2","c2592ea5f":"GoogleLogin_c2592ea5f__Ap520"};